import i18n from 'i18next'
import { reactI18nextModule } from 'react-i18next'
import message_en from './l10n/locale/en'
import message_fr from './l10n/locale/fr'
import message_nl from './l10n/locale/nl_BE'
import { currentLocale } from './services/translationService'

i18n.use(reactI18nextModule).init({
  fallbackLng: currentLocale(),
  debug: process.env.REACT_APP_I18N_DEBUG === 'true',
  resources: {
    nl_BE: {
      translation: message_nl,
    },
    en_US: {
      translation: message_en,
    },
    fr_FR: {
      translation: message_fr,
    },
  },
  keySeparator: false,
  nonExplicitWhitelist: true,
  whitelist: ['en_US', 'nl_BE', 'fr_FR'],
  interpolation: {
    escapeValue: false,
    formatSeparator: ',',
  },
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n.js